import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormControl } from '@angular/forms';

import { IAccount } from '@account-users';

@Component({
  selector: 'app-re-bootstrap-templates-modal',
  templateUrl: './re-bootstrap-templates-modal.component.html',
  styleUrls: ['./re-bootstrap-templates-modal.component.scss'],
})
export class RebBootstrapTemplatesModalComponent {
  @Input() accounts: IAccount[] = [];
  @Input() allAccounts = false;
  @Output() reBootstrap = new EventEmitter<string>();

  account = new FormControl('', Validators.required);
  filter = '';

  constructor(public activeModal: NgbActiveModal) {}

  get filteredAccounts() {
    const filter = new RegExp(this.filter, 'i');

    return this.accounts.filter((account) =>
      filter.test(`${account.displayName}${account.id}`),
    );
  }

  onSubmit() {
    this.reBootstrap.emit(this.account.value);
  }
}
